export class FetchUserAreasAction {
  static readonly type = '[Area] Fetch User Areas';
}
